<template>
  <div id="app" class="relative">
    <a
      v-if="mobile"
      class="fixed top-5 right-5 w-11 h-9 z-30"
      href="https://latale.papayaplay.com/latale.do"
      target="_blank"
    >
      <img :src="`${imgPath}/home_m.png`" />
    </a>
    <hamburger v-if="mobile" />
    <transition name="fade">
      <menu-nav-mobile v-if="mobileNav" />
    </transition>
    <menu-nav
      v-show="!mobile"
      :activeSection="activeSection"
      :moveTo="moveTo"
      class="menu-nav invisible"
    />
    <link-navigation v-show="!mobile" class="link-nav invisible" />
    <top-navigation v-show="activeSection >= 1 && !mobile" :moveTo="moveTo" />

    <transition name="fade">
      <class-slider
        v-show="mainSliderActive && classMenuData[0].isActive"
        :classSlider="mainSliderData"
      />
    </transition>
    <transition name="fade">
      <class-slider
        v-show="subSliderActive && classMenuData[1].isActive"
        :classSlider="subSliderData"
      />
    </transition>
    <transition name="fade">
      <summon-slider v-show="summonSlider" />
    </transition>
    <full-page ref="fullpage" :options="options" id="fullpage" v-if="!mobile">
      <div class="section bg-top-section">
        <img
          class="light-0 absolute left-0 bottom-0 w-full z-20"
          :src="`${imgPath}/slide1/bg_light0.png`"
        />
        <img
          class="light-1 absolute right-0 top-0 z-20"
          :src="`${imgPath}/slide1/bg_light2.png`"
        />
        <img
          class="light-2 absolute right-0 left-0 top-0 m-auto z-20"
          :src="`${imgPath}/slide1/bg_light3.png`"
        />
        <img
          class="light-3 absolute left-0 top-0 z-20"
          :src="`${imgPath}/slide1/bg_light4.png`"
        />
        <img
          class="plants absolute left-0 bottom-0 w-full z-20 invisible"
          :src="`${imgPath}/slide1/bg_obj1.png`"
        />
        <img
          class="absolute left-0 bottom-0 w-full z-10"
          :src="`${imgPath}/slide1/bg_bottom.png`"
        />
        <div class="content-wrapper h-full">
          <top-section :topAnimation="topAnimation" />
        </div>
      </div>

      <div class="section bg-content-section">
        <img
          class="bg-light-1 absolute top-0 left-0 w-full transform -scale-x-1 invisible"
          :src="`${imgPath}/slide2/2_bg_light1.png`"
        />
        <img
          class="bg-light-2 absolute bottom-0 left-0 w-full invisible"
          :src="`${imgPath}/slide2/2_bg_light2.png`"
        />
        <div class="content-wrapper w-full h-full">
          <content-section :moveTo="moveTo" />
        </div>
      </div>

      <div class="section bg-story-section">
        <img
          class="character3 absolute left-0 bottom-0 w-100vh invisible xl:visible"
          :src="`${imgPath}/slide3/character3.png`"
        />
        <img
          class="character1 absolute right-0 bottom-0 z-10 w-100vh invisible xl:-right-1.5/10 xl:visible"
          :src="`${imgPath}/slide3/character1.png`"
        />
        <img
          class="character2 absolute right-0 top-0 w-100vh invisible xl:visible"
          :src="`${imgPath}/slide3/character2.png`"
        />
        <img
          class="rock absolute left-0 bottom-0 w-full z-20 invisible xl:visible"
          :src="`${imgPath}/slide3/bottom_obj.png`"
        />
        <img
          class="feather1 absolute -left-0.5/10 -top-2.2/10 z-20 transform rotate-90 invisible xl:visible"
          :src="`${imgPath}/slide3/feather.png`"
        />
        <img
          class="feather2 absolute left-0 top-3/10 z-20 invisible xl:visible"
          :src="`${imgPath}/slide3/feather.png`"
        />
        <img
          class="feather3 absolute right-0 top-2/10 z-20 invisible xl:visible"
          :src="`${imgPath}/slide3/feather.png`"
        />
        <div class="content-wrapper w-full h-full">
          <story-section />
        </div>
      </div>

      <div class="section bg-class-section">
        <img
          class="purple-feather absolute left-0 bottom-0 xl:visible"
          :src="`${imgPath}/slide4/feather02.png`"
        />
        <img
          class="blue-feather absolute right-0 -top-2/10 xl:visible"
          :src="`${imgPath}/slide4/feather02_sm.png`"
        />
        <div class="content-wrapper h-full">
          <class-section />
        </div>
      </div>

      <div class="section bg-dungeon-section">
        <div class="content-wrapper h-full">
          <dungeon-section />
        </div>
      </div>
      <div class="section bg-skill-section">
        <img
          class="purple-hair absolute right-0 -bottom-10 invisible"
          :src="`${imgPath}/slide6/character_legend_skill.png`"
        />
        <div class="content-wrapper h-full">
          <skill-section />
        </div>
      </div>
      <div class="section bg-champions-section">
        <div class="content-wrapper h-full">
          <champions-section />
        </div>
      </div>
      <div class="section bg-summon-section">
        <img
          class="fire absolute right-0 bottom-0"
          :src="`${imgPath}/slide8/fire_flicker.png`"
        />
        <div class="content-wrapper h-full">
          <summon-section />
        </div>
      </div>
      <div class="section bg-stat-section">
        <div class="content-wrapper h-full">
          <stat-section />
        </div>
      </div>
      <div class="section bg-companion-section">
        <div class="content-wrapper h-full">
          <companion-section />
        </div>
      </div>
      <div class="section bg-combat-section">
        <div class="content-wrapper h-screen">
          <combat-section />
        </div>
      </div>
    </full-page>
    <div v-if="mobile">
      <top-section-mobile />
      <content-section-mobile />
      <story-section-mobile />
      <class-section-mobile />
      <dungeon-section-mobile />
      <skill-section-mobile />
      <champion-secton-mobile />
      <summon-section-mobile />
      <stat-section-mobile />
      <companion-section-mobile />
      <combat-section-mobile />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import breakpoints from './plugins/breakpoints';
import TopSection from './container/TopSection.vue';
import ContentSection from './container/ContentSection';
import StorySection from './container/StorySection';
import ClassSection from './container/ClassSection';
import DungeonSection from './container/DungeonSection.vue';
import SkillSection from './container/SkillSection.vue';
import ChampionsSection from './container/ChampionsSection.vue';
import SummonSection from './container/SummonSection.vue';
import StatSection from './container/StatSection.vue';
import CompanionSection from './container/CompanionSection.vue';
import CombatSection from './container/CombatSection.vue';
import MenuNav from './components/Navigation/MenuNavigation.vue';
import LinkNavigation from './components/Navigation/LinkNavigation.vue';
import TopNavigation from './components/Navigation/TopNavigation.vue';
import ClassSlider from './components/ClassSlider/ClassSlider.vue';
import SummonSlider from './components/SummonSlider/SummonSlider.vue';
import TopSectionMobile from './container/TopSectionMobile.vue';
import ContentSectionMobile from './container/ContentSectionMobile.vue';
import StorySectionMobile from './container/StorySectionMobile.vue';
import ClassSectionMobile from './container/ClassSectionMobile';
import DungeonSectionMobile from './container/DungeonSectionMobile.vue';
import SkillSectionMobile from './container/SkillSectionMobile.vue';
import ChampionSectonMobile from './container/ChampionSectonMobile.vue';
import SummonSectionMobile from './container/SummonSectionMobile.vue';
import StatSectionMobile from './container/StatSectionMobile.vue';
import CompanionSectionMobile from './container/CompanionSectionMobile.vue';
import CombatSectionMobile from './container/CombatSectionMobile.vue';
import MenuNavMobile from './components/Navigation/MenuNavMobile.vue';
import Hamburger from './components/Hamburger/Hamburger.vue';

export default {
  name: 'App',
  components: {
    TopSection,
    ContentSection,
    StorySection,
    ClassSection,
    DungeonSection,
    SkillSection,
    ChampionsSection,
    SummonSection,
    StatSection,
    CompanionSection,
    CombatSection,
    MenuNav,
    LinkNavigation,
    TopNavigation,
    ClassSlider,
    SummonSlider,
    TopSectionMobile,
    ContentSectionMobile,
    StorySectionMobile,
    ClassSectionMobile,
    DungeonSectionMobile,
    SkillSectionMobile,
    ChampionSectonMobile,
    SummonSectionMobile,
    StatSectionMobile,
    CompanionSectionMobile,
    CombatSectionMobile,
    MenuNavMobile,
    Hamburger,
  },
  data: function() {
    return {
      breakpoints,
      activeSection: 0,
      topAnimation: false,
      mobile: false,
      options: {
        licenseKey: '22B14707-790C4BCB-A9C092BF-C125B4EC',
        navigation: false,
        scrollOverflow: true,
        afterLoad: this.afterLoad,
        afterReBuild: this.afterReBuild,
      },
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
  methods: {
    moveTo: function(index) {
      this.$refs.fullpage.api.moveTo(index);
    },
    afterLoad(origin, destination, direction) {
      var vm = this;
      // console.log(origin, destination, direction);
      // console.log(destination);
      vm.activeSection = destination.index;
      //console.log('Active Slide', vm.activeSection);
      this.$store.commit('FULLPAGE/GET_ACTIVE_SECTION', destination.index);
      // Content section handle animation
      if (vm.activeSection === 1) {
        vm.init_section1_animation();
      } else {
        vm.disable_section1_animation();
      }
      // Story section handle animation
      if (vm.activeSection === 2 && this.breakpoints.w > 1366) {
        vm.init_section2_animation();
      } else if (vm.activeSection != 2 && this.breakpoints.w > 1366) {
        vm.disable_section2_animation();
      }
      // Class section handle animation
      if (vm.activeSection === 3 && this.breakpoints.w > 1366) {
        vm.init_section3_animation();
      } else if (vm.activeSection != 3 && this.breakpoints.w > 1366) {
        vm.disable_section3_animation();
      }
      // skill section handle animation
      if (vm.activeSection === 5 && this.breakpoints.w > 1366) {
        vm.init_section5_animation();
      } else if (vm.activeSection != 5 && this.breakpoints.w > 1366) {
        vm.disable_section5_animation();
      }
      // summon section handle animation
      if (vm.activeSection != 7 && this.breakpoints.w > 1366) {
        vm.init_section7_animation();
      }
    },
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_TOP_SECTION');
    },
    init_section1_animation: function() {
      this.$store.commit('ANIMATION/INIT_CONTENT_SECTION');
    },
    disable_section1_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_CONTENT_SECTION');
    },
    init_section2_animation: function() {
      this.$store.commit('ANIMATION/INIT_STORY_SECTION');
    },
    disable_section2_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_STORY_SECTION');
    },
    init_section3_animation: function() {
      this.$store.commit('ANIMATION/INIT_CLASS_SECTION');
    },
    disable_section3_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_CLASS_SECTION');
    },
    init_section5_animation: function() {
      this.$store.commit('ANIMATION/INIT_SKILL_SECTION');
    },
    disable_section5_animation: function() {
      this.$store.commit('ANIMATION/DISABLE_SKILL_SECTION');
    },
    init_section7_animation: function() {
      this.$store.commit('ANIMATION/INIT_SUMMON_SECTION');
    },
  },
  watch: {
    mainSliderActive: function(newVal, oldVal) {
      //console.log('mainSliderActive', newVal, oldVal);
      if (newVal && !this.mobile) {
        this.$refs.fullpage.api.setAllowScrolling(false);
      } else if (!this.mobile) {
        this.$refs.fullpage.api.setAllowScrolling(true);
      }
    },
    subSliderActive: function(newVal, oldVal) {
      //console.log('subSliderActive', newVal, oldVal);
      if (newVal && !this.mobile) {
        this.$refs.fullpage.api.setAllowScrolling(false);
      } else if (!this.mobile) {
        this.$refs.fullpage.api.setAllowScrolling(true);
      }
    },
    summonSliderActive: function(newVal, oldVal) {
      //console.log('summonSliderActive', newVal, oldVal);
      if (newVal) {
        this.$refs.fullpage.api.setAllowScrolling(false);
      } else {
        this.$refs.fullpage.api.setAllowScrolling(true);
      }
    },
    getBreakpoints: function(newVal, oldVal) {
      //console.log(`mobile ${newVal}`);
      if (newVal) {
        this.topAnimation = false;
        this.$refs.fullpage.api.destroy();
      } else {
        setTimeout(() => {
          this.$refs.fullpage.api.reBuild();
          this.topAnimation = true;
          this.initAnimation();
        }, 1400);
      }
    },
  },
  computed: {
    ...mapState({
      mainSliderActive: state => state.ClassSection.mainSliderActive,
      subSliderActive: state => state.ClassSection.subSliderActive,
      mainSliderData: state => state.ClassSection.mainSliderData,
      subSliderData: state => state.ClassSection.subSliderData,
      classMenuData: state => state.ClassSection.menuData,
      summonSlider: state => state.SummonSection.summonSlider,
      mobileNav: state => state.MenuNavMobile.mobileNav,
    }),
    ...mapGetters([
      'mainSliderActive',
      'subSliderActive',
      'summonSliderActive',
    ]),
    getBreakpoints() {
      // console.log(
      //   `computed, ${breakpoints.w} ${breakpoints.h} ${breakpoints.is}`,
      // );
      if (breakpoints.w <= 640) {
        //console.log('mobile');
        return (this.mobile = true);
      } else {
        return (this.mobile = false);
      }
    },
  },
  created: function() {
    window.addEventListener('load', this.initAnimation);
  },
};
</script>

<style lang="postcss" scoped>
.section {
  @apply overflow-hidden relative bg-cover bg-center bg-no-repeat w-full;
}
.section .content-wrapper {
  @apply w-full max-w-1920 mx-auto;
}
</style>
